import { BitcoinAddressHelper } from "@orangekit/sdk";
import { ethers } from "ethers";
export class OrangeKitBitcoinProvider {
    #provider;
    constructor(_provider) {
        this.#provider = _provider;
    }
    async disconnect() {
        if (typeof this.#provider.disconnect === "function") {
            await this.#provider.disconnect();
        }
        return Promise.resolve();
    }
    async connect() {
        const accounts = await this.#provider.requestAccounts();
        return accounts[0];
    }
    isInstalled() {
        return !!this.#provider;
    }
    async getAddress() {
        const accounts = await this.#provider.getAccounts();
        return accounts[0];
    }
    async getBalance() {
        const balance = await this.#provider.getBalance();
        return balance;
    }
    async signMessage(message) {
        const signature = await this.#provider.signMessage(message);
        const signatureBytes = ethers.decodeBase64(signature);
        const v = signatureBytes[0];
        let normalizedV;
        const [address] = await this.#provider.getAccounts();
        if (BitcoinAddressHelper.isP2WPKHAddress(address)) {
            // For p2wpkh, normalize to the 39-42 range specified by BIP137.
            normalizedV = BitcoinAddressHelper.normalizeV(v, 39);
        }
        else if (BitcoinAddressHelper.isP2PKHAddress(address)) {
            // For p2pkh, assume that an uncompressed p2pkh signature will already be
            // in the right range, and normalize any others to the 31-34 range
            // specified by BIP137.
            normalizedV =
                // BIP137 range for uncompressed p2pkh
                v >= 27 && v <= 30
                    ? v
                    : // BIP137 range for compressed p2pkh
                        BitcoinAddressHelper.normalizeV(v, 31);
        }
        else if (BitcoinAddressHelper.isNestedSegwitAddress(address, await this.getPublicKey())) {
            normalizedV = BitcoinAddressHelper.normalizeV(v, 35);
        }
        else {
            throw new Error("Unsupported Bitcoin address type");
        }
        signatureBytes[0] = normalizedV;
        return ethers.hexlify(signatureBytes);
    }
    async sendBitcoin(to, satoshis) {
        return this.#provider.sendBitcoin(to, satoshis);
    }
    async getPublicKey() {
        return this.#provider.getPublicKey();
    }
}
//# sourceMappingURL=bitcoin-wallet-provider.js.map